import React, { useState, useEffect } from 'react';
import { Link as RouterLink, Redirect } from 'react-router-dom';

import { IconButton } from '@material-ui/core';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/core/Alert';
import { makeStyles } from '@material-ui/core/styles';
import ModeEditOutlineTwoToneIcon from '@material-ui/icons/ModeEditOutlineTwoTone';

//Redux
import { useSelector, useDispatch } from "react-redux";
import { CLEAR_MESSAGE } from "../redux/actions/types";


const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});






const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
  alert: {
    maxWidth: '350px',
  },

}));



export default function CustomizedSnackbars() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { snackBar } = useSelector(state => state.ui)
  const [open, setOpen] = useState(false);
  
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
    dispatch({type: CLEAR_MESSAGE});
  };






  useEffect(() => {
    if(snackBar){
        setOpen(true)
    } else {
        setOpen(false)
    }
  }, [snackBar])

  const action = data => (
    <IconButton color="secondary" size="small"
    component={RouterLink}
    // edge="end"
    to={data}
    onClick={handleClose}
    >
     <ModeEditOutlineTwoToneIcon fontSize="medium" color="primary" />
    </IconButton>
  );


  return (
      <div className={classes.root}>
      <Snackbar className={`snackBar-${snackBar && snackBar.type ? snackBar.type : 'info'}`} onClose={handleClose} open={open} autoHideDuration={5000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      action={snackBar && snackBar.href ? action(snackBar.href) : null}
      message={snackBar && snackBar.message}
     />
        {/* <Alert onClose={handleClose} severity={snackBar && snackBar.type} className={classes.alert}
        >
          {snackBar && snackBar.message}
        </Alert>
      </Snackbar> */}
      </div>
  );
}
